import { render, staticRenderFns } from "./GainOnSale1.vue?vue&type=template&id=580812b4&"
import script from "./GainOnSale1.vue?vue&type=script&lang=js&"
export * from "./GainOnSale1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports